import baseGetTag from './_baseGetTag.js';
import isObjectLike from './isObjectLike.js';

var arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
}

export default baseIsArrayBuffer;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseIsArrayBuffer.js
// module id = 1114
// module chunks = 0